export default new Promise((resolve) => {
	const interval = window.setInterval(() => {
		if (typeof window.AP === 'object') {
			clearInterval(interval);
			resolve();
		}
		// Using the shortest timeout possible to avoid Dark Mode flashing
	}, 10);
});
